import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from "react";
import Image from "../../../../../base/multimedia/image/index.js";
import contextBabylon from "../../../../../../context/index.js";
import { getCurrencySymbol } from "../../../../../../helpers/currency/index.js";
import { nullsToUndefined } from "../../../../../../helpers/null.js";
import { CARD_SIMPLE_CONSTANTS } from "../../constants.js";
import * as S from "./styled.js";
const CardSimpleDesktop = ({ title ='' , subtitle , price , image , link , config , height , className  })=>{
    const { Currency  } = useContext(contextBabylon);
    const { alternative  } = image ?? {};
    return /*#__PURE__*/ _jsxs(S.CardSimpleWrapperDesktop, {
        "data-testid": "CardSimpleDesktop",
        $height: height,
        className: className,
        children: [
            /*#__PURE__*/ _jsx(Image, {
                resize: {
                    width: 350,
                    height: 250,
                    quality: 85
                },
                ...image,
                alternative: alternative ? alternative : CARD_SIMPLE_CONSTANTS.DEFAULT_IMAGE
            }),
            /*#__PURE__*/ _jsxs(S.CardSimpleContentDesktop, {
                ...nullsToUndefined(link),
                children: [
                    title && /*#__PURE__*/ _jsx(S.CardSimpleTitleDesktop, {
                        content: title
                    }),
                    subtitle && /*#__PURE__*/ _jsx(S.CardSimpleSubtitleDesktop, {
                        content: subtitle
                    }),
                    !!price && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            /*#__PURE__*/ _jsx(S.CardSimpleFromDesktop, {
                                children: config?.literals?.from
                            }),
                            /*#__PURE__*/ _jsxs(S.CardSimplePriceDesktop, {
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "price",
                                        children: Math.floor(price)
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "currency",
                                        children: getCurrencySymbol(Currency)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
export default CardSimpleDesktop;

//# sourceMappingURL=index.js.map